import { render } from "./tags-steps.vue?vue&type=template&id=1fb768e4"
import script from "./tags-steps.vue?vue&type=script&lang=js"
export * from "./tags-steps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__